export class Dimension {
  dimensionId: string;
  name: string;

  constructor(id: string) {
    this.dimensionId = id;
    this.name = id;
  }
}

export const ChannelPartnersDiamond = new Dimension('Diamond');
export const ChannelPartnersPlatinum = new Dimension('Platinum');
export const ChannelPartnersGold = new Dimension('Gold');
export const ChannelPartnersSilver = new Dimension('Silver');
export const ChannelPartnersUnassisted = new Dimension('Unassisted');
export const ChannelPartnersChurned = new Dimension('Churned Partners');
export const ChannelPartnersPreSales = new Dimension('Pre-Sales');
export const ChannelPartnersUnassigned = new Dimension('Unassigned');
export const ChannelPartnersMedia = new Dimension('Media');
export const ChannelPartnersBroadcast = new Dimension('Broadcast');
export const ChannelPartnersISV = new Dimension('ISV');
export const ChannelPartnersICT = new Dimension('ICT');
export const ChannelPartnersFranchise = new Dimension('Franchise');
export const ChannelPartnersBroadly = new Dimension('Broadly');
export const ChannelPartnersEMEA = new Dimension('EMEA');
export const ChannelPartnersAgency = new Dimension('Agency');
export const ChannelPartnersHighVelocityExpansion = new Dimension('High Velocity Expansion');
export const ChannelPartnersHighVelocityAcquisition = new Dimension('High Velocity Acquisition');

export const LEGACY_DIMENSIONS = [
  ChannelPartnersDiamond,
  ChannelPartnersPlatinum,
  ChannelPartnersGold,
  ChannelPartnersSilver,
  ChannelPartnersUnassisted,
  ChannelPartnersChurned,
  ChannelPartnersPreSales,
  ChannelPartnersUnassigned,
];

export const SERVICE_TIERS = [
  ChannelPartnersMedia,
  ChannelPartnersBroadcast,
  ChannelPartnersISV,
  ChannelPartnersICT,
  ChannelPartnersFranchise,
  ChannelPartnersBroadly,
  ChannelPartnersEMEA,
  ChannelPartnersAgency,
  ChannelPartnersHighVelocityExpansion,
  ChannelPartnersHighVelocityAcquisition,
];
